/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const arrow_left_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M22.25 11.5H2M9.5 4 2 11.5m0 0L9.5 19"
    />
  </svg>
)
export default arrow_left_medium
